import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=3f2533b7&scoped=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=3f2533b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2533b7",
  null
  
)

export default component.exports